"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var elmer_common_1 = require("elmer-common");
var defineReduxProvider_1 = require("./defineReduxProvider");
var ReduxGlobalStateKeys_1 = require("./ReduxGlobalStateKeys");
var ReduxController = /** @class */ (function (_super) {
    __extends(ReduxController, _super);
    function ReduxController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateData = {};
        _this.stateWatchs = {};
        _this.reducers = {};
        _this.reducersData = {};
        _this.initComponents = [];
        _this.autoSave = false;
        _this.saveDataKey = "ElmerReduxState";
        return _this;
    }
    ReduxController.prototype.setNotifyCallback = function (callbackNames) {
        this.notifyCallbackNames = callbackNames;
    };
    ReduxController.prototype.checkInitStateData = function (getGlobalState, defineGlobalState) {
        if (!getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_STATE_KEY)) {
            defineReduxProvider_1.defineReduxProvider(getGlobalState, defineGlobalState);
        }
        this.getGlobalState = getGlobalState;
        this.defineGlobalState = defineGlobalState;
        this.stateData = !this.stateData ? getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_STATE_KEY) : __assign(__assign({}, this.stateData), getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_STATE_KEY));
        this.stateWatchs = !this.stateWatchs ? (getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_LISTEN_KEY) || {}) : __assign(__assign({}, this.stateWatchs), (getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_LISTEN_KEY) || {}));
    };
    ReduxController.prototype.connect = function (selector, mapStateToProps, mapDispatchToProps) {
        if (!this.isEmpty(selector)) {
            if (!this.stateWatchs[selector]) {
                this.defineReadOnlyProperty(this.stateWatchs, selector, {
                    mapDispatchToProps: mapDispatchToProps,
                    mapStateToProps: mapStateToProps
                });
            }
        }
    };
    /**
     * 根据做connect操作selector获取state
     * @param selector string 组件tagName
     */
    ReduxController.prototype.getStateByConnectSelector = function (selector) {
        var stateData = this.getStates();
        var listenData = this.getWatches();
        if (Object.keys(listenData).indexOf(selector) >= 0) {
            var listen = listenData[selector];
            return typeof listen.mapStateToProps === "function" && listen.mapStateToProps.call(this, stateData, this);
        }
    };
    ReduxController.prototype.getDispatchByConnectSelector = function (selector) {
        var watches = this.getWatches();
        if (Object.keys(watches).indexOf(selector) >= 0) {
            var listen = watches[selector];
            return typeof listen.mapDispatchToProps === "function" && listen.mapDispatchToProps.call(this, this.dispatch.bind(this), this);
        }
    };
    ReduxController.prototype.checkInitComponents = function (targetComponent, selector, nodeData) {
        var keysData = Object.keys(this.getWatches());
        for (var _i = 0, keysData_1 = keysData; _i < keysData_1.length; _i++) {
            var tmpKey = keysData_1[_i];
            if (tmpKey === selector) {
                if (this.isEmpty(this.initComponents[selector])) {
                    this.initComponents[selector] = {};
                }
                this.initComponents[selector][nodeData.virtualID] = targetComponent;
                break;
            }
        }
        keysData = null;
    };
    ReduxController.prototype.removeComponent = function (selector, nodeData) {
        if (this.initComponents[selector]) {
            this.initComponents[selector][nodeData.virtualID] = null;
            delete this.initComponents[selector][nodeData.virtualID];
            if (Object.keys(this.initComponents[selector]).length <= 0) {
                delete this.initComponents[selector];
            }
        }
    };
    ReduxController.prototype.dispatch = function (pushState) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        try {
                            _this.doDispatch(pushState);
                            if (_this.autoSave) {
                                _this.saveStore.setItem(_this.saveDataKey, JSON.stringify(_this.stateData));
                            }
                            resolve({
                                message: "success",
                                status: 200,
                            });
                        }
                        catch (e) {
                            reject({
                                message: e.message,
                                stack: e.stack,
                                status: 500
                            });
                        }
                    })];
            });
        });
    };
    ReduxController.prototype.getStates = function () {
        var stateData = !this.stateData ? this.getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_STATE_KEY) : __assign(__assign({}, this.stateData), this.getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_STATE_KEY));
        return stateData;
    };
    ReduxController.prototype.getWatches = function () {
        var listeners = !this.stateWatchs ? (this.getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_LISTEN_KEY) || {}) : __assign(__assign({}, this.stateWatchs), (this.getGlobalState(ReduxGlobalStateKeys_1.REDUX_GLOBAL_LISTEN_KEY) || {}));
        return listeners;
    };
    ReduxController.prototype.doDispatch = function (pushState) {
        var _this = this;
        if (!this.isEmpty(pushState) && !this.isEmpty(pushState.type)) {
            // 这里做dispatch操作
            var reducerKeys = Object.keys(this.reducers);
            var stateData = this.getStates();
            var _loop_1 = function (tmpReducerKey) {
                var oldData = this_1.getValue(stateData, tmpReducerKey);
                var oldStateData = oldData !== undefined && null !== oldData ? JSON.parse(JSON.stringify(oldData)) : oldData;
                var checkReducer = this_1.reducers[tmpReducerKey];
                var newState = checkReducer(oldStateData, pushState, {
                    extend: this_1.extend
                });
                if (JSON.stringify(oldData) !== JSON.stringify(newState)) {
                    // reducer返回结果与state树上的数据不一致时，认为已经更新了
                    var updateState_1 = {};
                    for (var _i = 0, _a = Object.keys(newState); _i < _a.length; _i++) {
                        var stateKey = _a[_i];
                        (function (defineStateKey, defineStateValue) {
                            _this.defineStateValue(defineStateValue);
                            Object.defineProperty(updateState_1, defineStateKey, {
                                configurable: true,
                                enumerable: true,
                                get: function () {
                                    return defineStateValue;
                                },
                                set: function () {
                                    // tslint:disable-next-line:no-console
                                    console.error("不允许直接修改Redux数据！", defineStateKey, defineStateValue);
                                }
                            });
                        })(stateKey, newState[stateKey]);
                    }
                    this_1.setValue(stateData, tmpReducerKey, updateState_1, function (obj, propertyKey, value) {
                        if (_this.isObject(obj) && !_this.isEmpty(propertyKey)) {
                            if (!_this.isEmpty(value)) {
                                delete obj[propertyKey];
                            }
                            Object.defineProperty(obj, propertyKey, {
                                configurable: true,
                                enumerable: true,
                                get: function () {
                                    return value || {};
                                },
                                set: function () {
                                    // tslint:disable-next-line:no-console
                                    console.error("不允许直接修改Redux数据！");
                                }
                            });
                        }
                    });
                    this_1.stateData = stateData;
                    this_1.checkChangeComponent();
                    return "break";
                }
            };
            var this_1 = this;
            for (var _i = 0, reducerKeys_1 = reducerKeys; _i < reducerKeys_1.length; _i++) {
                var tmpReducerKey = reducerKeys_1[_i];
                var state_1 = _loop_1(tmpReducerKey);
                if (state_1 === "break")
                    break;
            }
            reducerKeys = null;
        }
        else {
            if (pushState && this.isEmpty(pushState.type)) {
                throw new Error("[ReduxController.dispatch] pushState未指定type属性");
            }
            else {
                throw new Error("[ReduxController.dispatch] pushState不是object对象");
            }
        }
    };
    ReduxController.prototype.defineStateValue = function (stateValue) {
        if (this.isObject(stateValue)) {
            Object.keys(stateValue).map(function (stateKey) {
                (function (propsKey, propsValue) {
                    // remove loop defineState, improve dispatch performence
                    Object.defineProperty(stateValue, propsKey, {
                        configurable: true,
                        enumerable: true,
                        get: function () {
                            return propsValue;
                        },
                        set: function () {
                            // tslint:disable-next-line:no-console
                            console.error("\u4E0D\u5141\u8BB8\u76F4\u63A5\u4FEE\u6539Redux\u6570\u636E\uFF01[" + stateKey + "]", stateValue);
                        }
                    });
                })(stateKey, stateValue[stateKey]);
            });
        }
    };
    ReduxController.prototype.checkChangeComponent = function () {
        var watchesData = this.getWatches();
        var watchKeys = Object.keys(watchesData);
        for (var _i = 0, watchKeys_1 = watchKeys; _i < watchKeys_1.length; _i++) {
            var wKey = watchKeys_1[_i];
            var tmpWatch = watchesData[wKey];
            if (typeof tmpWatch.mapStateToProps === "function") {
                var mapState = tmpWatch.mapStateToProps.call(this, this.getStates(), this);
                this.checkChangeForComponent(mapState, wKey);
                mapState = null;
            }
            tmpWatch = null;
        }
        watchKeys = null;
        watchesData = null;
    };
    ReduxController.prototype.checkChangeForComponent = function (mapState, selector) {
        var _this = this;
        Object.keys(this.initComponents).map(function (tmpSelector) {
            if (tmpSelector === selector) {
                // 只对项目mapStateToPros，connect的组件做检查
                var tmpComponents = _this.initComponents[tmpSelector];
                var _loop_2 = function (virtualID) {
                    var tmpComponent = tmpComponents[virtualID];
                    var checkProps = tmpComponent.props || {};
                    var hasChanged = false;
                    for (var mapKey in mapState) {
                        if (mapState && JSON.stringify(mapState[mapKey]) !== JSON.stringify(checkProps[mapKey])) {
                            hasChanged = true;
                            delete checkProps[mapKey];
                            _this.defineReadOnlyProperty(checkProps, mapKey, mapState[mapKey]);
                        }
                    }
                    if (hasChanged) {
                        if (_this.notifyCallbackNames && _this.notifyCallbackNames.length > 0) {
                            // 设置多个callback为了兼容旧版本代码
                            _this.notifyCallbackNames.map(function (callbackName) {
                                typeof tmpComponent[callbackName] === "function" && tmpComponent[callbackName].call(tmpComponent, checkProps);
                            });
                        }
                    }
                    tmpComponent = null;
                    checkProps = null;
                };
                // tslint:disable-next-line:forin
                for (var virtualID in tmpComponents) {
                    _loop_2(virtualID);
                }
                tmpComponents = null;
            }
        });
    };
    ReduxController.className = "ReduxController";
    return ReduxController;
}(elmer_common_1.Common));
exports.ReduxController = ReduxController;
